
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rpxzfdofspoaogoxcmam.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJweHpmZG9mc3BvYW9nb3hjbWFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM5Mjg5NTEsImV4cCI6MjA1OTUwNDk1MX0.VERnTR8G6jEKVFh-PIirgZnjy2TYTmBWDhy4Bb7KRVM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'blog-admin-auth'
  }
});
